export const PAYMENT_REQUIREMENTS_INCOMING_MODULE_NAME: string = 'incoming';

export enum PaymentRequirementsIncomingAction {
	loadUnprocessed = 'loadUnprocessed',
	signUnprocessed = 'signUnprocessed',
	loadCardIndexDetails = 'loadCardIndexDetails',
	cachedLoadCardIndexDetails = 'cachedLoadCardIndexDetails',
	deleteDenieFile = 'deleteDenieFile',
	uploadDenieFile = 'uploadDenieFile',
	loadDenieFiles = 'loadDenieFiles',
	refusePayment = 'refusePayment',
	createPayment = 'createPayment',
}

export enum PaymentRequirementsIncomingMutation {
	setUnprocessedList = 'setUnprocessedList',
	setUnprocessedListLoading = 'setUnprocessedListLoading',
	setUnprocessedListShowed = 'setUnprocessedListShowed',
	setCardIndexDetails = 'setCardIndexDetails',
}

export enum PaymentRequirementsIncomingGetter {
	unprocessedList = 'unprocessedList',
	unprocessedListLoading = 'unprocessedListLoading',
	unprocessedListShowed = 'unprocessedListShowed',
	unprocessedCount = 'unprocessedCount',
	cardIndexDetails = 'cardIndexDetails',
}